import React from "react";

interface Props {
  className?: string;
  on: boolean;
}

const ToggleSwitch: React.FC<Props> = ({ className, on }) => {
  return (
    <svg
      width="40"
      height="20"
      viewBox="0 0 40 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="40"
        height="20"
        rx="10"
        fill={
          on ? "var(--backgroundSuccess)" : "var(--switch_toggle_off_color_1)"
        }
        style={{ transition: "fill 0.2s ease-in-out" }}
      />
      <circle
        cx={on ? "30" : "10"}
        cy="10"
        r="8"
        fill="white"
        style={{ transition: "cx 0.2s ease-in-out" }}
      />
    </svg>
  );
};

export default ToggleSwitch;
